export default {
  data() {
    return {
      allLangs: [
        { id: 1, name: this.$t('langs.ua') },
        { id: 2, name: this.$t('langs.ru') },
        { id: 3, name: this.$t('langs.en') },
        { id: 15, name: this.$t('langs.de') },
        { id: 24, name: this.$t('langs.fr') }
      ]
    }
  }
}
